import { render, staticRenderFns } from "./ProductListWrapper.vue?vue&type=template&id=ad7e2a16&scoped=true&"
import script from "./ProductListWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProductListWrapper.vue?vue&type=style&index=0&id=ad7e2a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7e2a16",
  null
  
)

export default component.exports